module.exports = __webpack_public_path__ + "img/dronzikov.d6e664c2.png";